var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#E6F805"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94727 4.31055C8.74805 4.31055 9.38672 4.50391 9.86328 4.89062C10.3398 5.27734 10.5781 5.79297 10.5781 6.4375C10.5781 6.87109 10.4805 7.24219 10.2852 7.55078C10.0938 7.85547 9.72266 8.20703 9.17188 8.60547C8.79297 8.88281 8.55469 9.09375 8.45703 9.23828C8.35938 9.38281 8.31055 9.57227 8.31055 9.80664V10.1582H6.75781V9.72461C6.75781 9.34961 6.83789 9.02344 6.99805 8.74609C7.1582 8.46484 7.44727 8.17383 7.86523 7.87305C8.28711 7.56836 8.5625 7.32617 8.69141 7.14648C8.82031 6.9668 8.88477 6.75586 8.88477 6.51367C8.88477 6.27148 8.79102 6.08398 8.60352 5.95117C8.41992 5.81836 8.1582 5.75195 7.81836 5.75195C7.23633 5.75195 6.56836 5.94336 5.81445 6.32617L5.17578 5.04297C6.05078 4.55469 6.97461 4.31055 7.94727 4.31055ZM6.57031 12.1562C6.57031 11.832 6.6582 11.5859 6.83398 11.418C7.00977 11.25 7.26172 11.166 7.58984 11.166C7.92188 11.166 8.17578 11.252 8.35156 11.4238C8.53125 11.5957 8.62109 11.8398 8.62109 12.1562C8.62109 12.4688 8.5293 12.7148 8.3457 12.8945C8.16602 13.0703 7.91406 13.1582 7.58984 13.1582C7.26953 13.1582 7.01953 13.0723 6.83984 12.9004C6.66016 12.7246 6.57031 12.4766 6.57031 12.1562Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltip);
export default __webpack_public_path__ + "static/media/InfoTooltip.574e751e.svg";
export { ForwardRef as ReactComponent };